// extracted by mini-css-extract-plugin
export default {"bottomBar":"BottomCommentsBar_bottomBar__dWISI"};